<ridango-ui-dialog-layout title="TERMS_AND_CONDITIONS">
    <iframe
        [src]="data.termsUrl | safeResourceUrl"
        title="{{ 'TERMS_CONDITIONS_TITLE' | translate }}"
        class="tnc__iframe tnc-middle">
    </iframe>

    <ng-container dialog-actions>
        <div
            class="flex"
            [ngClass]="{
                'flex-align-center flex-justify-between': !env.USE_TAILWIND,
                'items-center justify-between': env.USE_TAILWIND
            }">
            <a
                tabindex="0"
                (click)="agreeTerms(false)"
                (keydown.enter)="agreeTerms(false)"
                (keydown.space)="agreeTerms(false)"
                class="link link--action link--emphasized"
                >{{ 'DECLINE' | translate }}</a
            >
            <div class="basis-1/3">
                <button
                    tabindex="0"
                    class="btn btn--primary btn--maximal"
                    (click)="agreeTerms(true)"
                    (keydown.enter)="agreeTerms(true)"
                    (keydown.space)="agreeTerms(true)">
                    {{ 'ACCEPT_TERMS' | translate }}
                </button>
            </div>
        </div>
    </ng-container>
</ridango-ui-dialog-layout>
